$(document).ready(function () {

    function initializeSlickSlider(wrapper) {
        var $wrapper = $(wrapper);
        var productsPerRow = $wrapper.data('products_per_row');
        $wrapper.find('.collection-products-list.active').slick({
            slidesToShow: parseInt(productsPerRow),
            slidesToScroll: parseInt(productsPerRow),
            nextArrow: '<button type="button" class="slick-next-custom"><svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="46" height="46" rx="23" fill="#676767"/><path d="M19.25 15.5L26.75 23L19.25 30.5" stroke="white" stroke-width="2"/></svg></button>',
            prevArrow: '<button type="button" class="slick-prev-custom"><svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="45" height="45" rx="22.5" stroke="#A9A9A9"/><path d="M26.75 15.5L19.25 23L26.75 30.5" stroke="#080808" stroke-width="2"/></svg></button>',
            infinite: true,
            dots: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: Math.min(2, parseInt(productsPerRow)),
                        slidesToScroll: Math.min(2, parseInt(productsPerRow)),
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    document.querySelectorAll('.collections-lists-product').forEach(function (section) {
        var wrapper = section.querySelector('.collections-product-wrapper');

        // Initialize slick slider for this section
        initializeSlickSlider(wrapper);

        // Tab click handler scoped to this section
        $(section).find('.collections-tabs-list li').on('click', function () {
            var tab_id = $(this).attr('data-collection-id');

            $(section).find('.collections-tabs-list li').removeClass('active');
            $(section).find('.collection-products-list').removeClass('active');

            $(this).addClass('active');
            $('#' + tab_id).addClass('active');

            // Reinitialize slick slider within this section only
            $(wrapper).find('.collection-products-list.slick-initialized').slick('unslick');
            initializeSlickSlider(wrapper);
        });
    });

});
